export const wrapperStyles = {
  marginTop: '8px',
};
